export default __webpack_public_path__ + "static/ProValue_1@992-7d2465e12a55fe7a889ab711da3b5db1.webp";